import { lazy } from "react";
import { ProtectedRoute } from "../components/ProtectedRoute";
import PasswordContextProvider from "../contexts/PasswordContext";

const applicationRouteConfig = [
  {
    parent: {
      exact: true,
      path: "/application-loan",
      element: ProtectedRoute,
      permission_id: 31,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/applying/DocumentApplicationLoan")),
      wrapper: PasswordContextProvider,
    },
  },
];

export default applicationRouteConfig;
